import {
  FlexRow,
  IneerSection,
  Line,
  SectionRole,
  Typography,
  FlexCol
} from "../../Global.style";
import { AddressSection, FooterBox ,Img} from "./footer.style";

import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
function Footer() {
  return (
    <SectionRole style={{background:"#2a2a2a", color:"#fff"}}>
      <IneerSection style={{ alignItems: "flex-start" }}>
        <FooterBox>
          <Typography style={{ margin: "0 0" }} fontSize={32}>
            العنوان
          </Typography>
          <Line
            style={{ marginRight: "0px" }}
            color={"#fcdd06bf"}
            height={"5px"}
          ></Line>
          <Line color={"#a0a0a0"} height={"1px"} width={"100%"}></Line>
          <AddressSection>
            <FlexCol>
              <FlexRow>
                <Typography fontSize={18}>
                  أنا تقني 
                </Typography>
              </FlexRow>
              <FlexRow style={{width:"30%"}}>
                <Typography fontSize={18}>متجر إلكتروني لبيع المنتجات الإلكترونية واكسسوارات الجوال بأفضل الاسعار,
                 مسجل رسميا بسجل تجاري رقم 4030601990, ومسجل في خدمة معروف من وزارة التجارة 
                 https://maroof.sa/39976</Typography>
              </FlexRow>
              <FlexRow>
                <Typography fontSize={18}> <Img width="20px" src="/tax.png"/> 
                  الرقم الضريبي : 310149436700003
                </Typography>
              </FlexRow>
            </FlexCol>  
            <FlexCol>
              <FlexRow>
                <Typography fontSize={18}>
                  <LocationOnIcon /> السعودية - جميع انحاء المملكة
                </Typography>
              </FlexRow>
              <FlexRow>
                <Typography fontSize={18}>
                  
                  <MailOutlineIcon /> info@anatiqani-store.com
                </Typography>
              </FlexRow>
              <FlexRow>
                <Typography fontSize={18}>
                  <PhoneIcon />
                  +966581645146
                </Typography>
              </FlexRow>
            </FlexCol>  
          </AddressSection>
        </FooterBox>
      </IneerSection>
    </SectionRole>
  );
}

export default Footer;
